import React,{useRef, useEffect} from 'react';
import styled from 'styled-components'
import NormalText from '../../Components/NormalText';
import Avatar from '../../Components/Avatar';
import { useQuery } from '@apollo/react-hooks';
import { IS_ME } from '../../Queries/isme';
import { media } from '../../styles/Mixin';
import { LeftArrow } from '../../icons';
import Cookies from 'js-cookie'
import ProfileMobileWindow from '../../Components/ProfileMobileWindow';

export default({
    isLoggedIn,
    loginClick,
    history,
    profileBtn,
    setProfileBtn,
    windowSize
})=>{
    const ref = useRef();
    const useOutsideClick = (ref, callback) => {
        const handleClick = e => {
            if (ref.current && !ref.current.contains(e.target)) {
                callback();
            }
        };

        useEffect(() => {
            window.addEventListener("click", handleClick);
            return () => {
                window.removeEventListener("click", handleClick);
            };
        });
    };
    useOutsideClick(ref, () => {
        if (profileBtn) setProfileBtn(false);
    });

    if(isLoggedIn){
        const{ data, loading} = useQuery(IS_ME)
        if(loading){
            return (
                <Wrapper>
                    <Row></Row>
                    <Row></Row>
                    <Row></Row>
                </Wrapper>
            )
        }else if(data && !loading){
            return(
                <Wrapper> 
                    <Row>
                        {
                            history.location.pathname !== "/" &&
                            (
                                <>
                                    <Style onClick={() => { setProfileBtn(false);history.goBack()}}>
                                        <LeftArrow />
                                    </Style>
                                    <CNormalText text={"댓글 홈 🌈"} onClick={() => { setProfileBtn(false);history.push("/") }} />
                                </>
                            )
                        }
                    </Row>
                    <Row></Row>
                    <Row>
                        {/* <CustomLinked to={`/${data.isMe.channelId}`}> */}
                        <CustomLinked onClick={() => { setProfileBtn(!profileBtn)}}>
                            <CustomAvatar url={data.isMe.profileImageUrl} size={"m_md"} />
                        </CustomLinked>
                    </Row>
                    {
                        profileBtn && windowSize > 500 &&
                        (
                            <ProfileWebWrapper ref={ref}>
                                <HeaderProfileBox>
                                    <MyChannelText text={"내 채널 가기"} onClick={() => { setProfileBtn(false);history.push(`/${data.isMe.channelId}`)}}/>
                                    <MyInfoText text={"내정보"} onClick={() => { setProfileBtn(false); history.push(`/myinfo`) }} />
                                    <LogOutText text={"로그아웃"} onClick={()=>{Cookies.remove("sessionId");window.location.assign("/")}}/>
                                </HeaderProfileBox>
                            </ProfileWebWrapper>
                        )
                    }
                    {
                            profileBtn && windowSize < 501 &&
                        (
                            <ProfileMobileWindow 
                                history={history}
                                setProfileBtn={setProfileBtn}
                                channelId ={data.isMe.channelId}
                            />
                        )
                    }
                </Wrapper>
            )
        }
    }else{
        return(
            <Wrapper>
                <Row>
                    {
                        history.location.pathname !== "/" &&
                        (
                            <>
                            <Style onClick={() => { return history.goBack() }}>
                                <LeftArrow />
                            </Style>
                                <CNormalText text={"댓글 홈 🌈"} onClick={()=>{return history.push("/")}}/>
                            </>
                        )
                    }
                </Row>
                <Row></Row>
                <Row>
                    {/* <LoginText onClick={loginClick} text={"구글 로그인"} /> */}
                </Row>
            </Wrapper>
        )
    }

}

const Wrapper = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    padding:10px;
`
const Row =styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`
const LoginText = styled(NormalText)`
  color:${props => props.theme.blueColor};
  cursor:pointer;
`
// const Style = styled(Link)`
//   ${media.deskTop`
//   width:30px;
//   height:30px;
//   `}
//   ${media.mobile`
//   width:20px;
//   height:20px;
//   `}
// `;
const Style = styled.div`
    cursor:pointer;
  ${media.deskTop`
  width:30px;
  height:30px;
  `}
  ${media.mobile`
  width:20px;
  height:20px;
  `}
`;

const CustomAvatar = styled(Avatar)`
    cursor:pointer;
`
const CustomLinked = styled.div`

`

const CNormalText = styled(NormalText)`
    cursor:pointer;
    padding-left:20px;
    padding-top:3px;
`

const ProfileWebWrapper = styled.div`
    ${media.mobile`
        display:none;
    `}
    position:fixed;
    top:55px;
    right:50px;
    width:200px;    
    /* height:200px; */
    z-index:10;
    background-color:white;
    box-shadow:0 1px 6px 0 rgba(32,33,36,0.28);
    display:flex;

`

const HeaderProfileBox = styled.div`
    /* position:relative; */
    padding:20px;
    display: flex;
    flex-direction:column;
    align-items:center;
    width:100%;
    
`

const LogOutText = styled(NormalText)`
    cursor:pointer;
`

const MyChannelText = styled(NormalText)`
    margin-bottom:20px;
    color:${props => props.theme.blueColor};
    cursor:pointer;
`

const MyInfoText = styled(NormalText)`
    margin-bottom:20px;
    cursor:pointer
`

